var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoProyecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 534.274,
    height: 270.021,
    viewBox: "0 0 534.274 270.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18575",
    "data-name": "Rectangle 18575",
    className: "cls-1",
    width: 534.274,
    height: 270.021
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Proyecto",
    "data-name": "Logo Proyecto",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7484",
    "data-name": "Path 7484",
    className: "cls-1",
    d: "M28.089,106.445a10.619,10.619,0,1,0,0,21.214H40.373a10.619,10.619,0,1,0,0-21.214Zm-6.581,10.61a6.823,6.823,0,0,1,6.943-6.67H40a6.674,6.674,0,1,1,0,13.338H28.451a6.824,6.824,0,0,1-6.943-6.668",
    transform: "translate(22.667 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7485",
    "data-name": "Path 7485",
    className: "cls-1",
    d: "M68.326,106.445v3.875H82.678v13.464H68.326v3.875h32.766v-3.875H86.957V110.32h14.135v-3.875Z",
    transform: "translate(91.357 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7486",
    "data-name": "Path 7486",
    className: "cls-1",
    d: "M91.679,106.445a6.313,6.313,0,1,0,0,12.626h19.652a2.337,2.337,0,1,1,0,4.672H86.063v3.917h25.766a6.252,6.252,0,1,0,0-12.5H92.179a2.4,2.4,0,1,1,0-4.8h25.266v-3.915Z",
    transform: "translate(114.084 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7487",
    "data-name": "Path 7487",
    className: "cls-1",
    d: "M220.9,106.445a6.313,6.313,0,1,0,0,12.626h19.678a2.337,2.337,0,1,1,0,4.672H215.3v3.917h25.776a6.253,6.253,0,1,0,0-12.5H221.4a2.4,2.4,0,0,1,0-4.8h25.3v-3.915Z",
    transform: "translate(286.846 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7488",
    "data-name": "Path 7488",
    className: "cls-1",
    d: "M123.919,106.445a10.611,10.611,0,1,0,0,21.214h20.239a1.956,1.956,0,0,0,1.982-1.94v-8.787a1.96,1.96,0,0,0-1.982-1.944H122.01v3.882H141.7v4.908H124.417a6.728,6.728,0,1,1,0-13.447H146.1v-3.884Z",
    transform: "translate(151.112 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7489",
    "data-name": "Path 7489",
    className: "cls-1",
    d: "M191.178,106.445a10.611,10.611,0,1,0,0,21.214h20.237a1.957,1.957,0,0,0,1.979-1.94v-8.787a1.961,1.961,0,0,0-1.979-1.944H189.247v3.882h19.694v4.908H191.659a6.727,6.727,0,1,1,0-13.447h21.683v-3.884Z",
    transform: "translate(241.038 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7490",
    "data-name": "Path 7490",
    className: "cls-1",
    d: "M199.531,106.445a1.962,1.962,0,0,0-1.968,1.956v17.306a1.965,1.965,0,0,0,1.968,1.951h29.751V123.75H202.006V119h27.276v-3.9H202.006v-4.75h27.276v-3.9Z",
    transform: "translate(264.156 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7491",
    "data-name": "Path 7491",
    className: "cls-1",
    d: "M34.153,106.445v21.214H38.6v-8.477H53.354c.1.044,8.18,8.514,8.18,8.514s5.637-.037,6.163-.042c-.376-.39-8.091-8.472-8.091-8.472h1.288a6.376,6.376,0,1,0,0-12.737Zm4.445,8.668V110.4H60.4a2.438,2.438,0,1,1,0,4.838H38.6Z",
    transform: "translate(45.665 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    className: "cls-1",
    d: "M51.5,106.445v21.214h4.45v-8.477H70.7c.089.044,8.17,8.514,8.17,8.514s5.642-.037,6.168-.042c-.376-.39-8.079-8.472-8.079-8.472h1.276a6.376,6.376,0,1,0,0-12.737Zm4.45,8.668V110.4h21.8a2.436,2.436,0,1,1,0,4.838H55.95Z",
    transform: "translate(68.854 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    className: "cls-1",
    d: "M147.258,106.445v21.214h4.447v-8.477h14.759c.093.044,8.173,8.514,8.173,8.514s5.637-.037,6.163-.042c-.381-.39-8.091-8.472-8.091-8.472h1.3a6.376,6.376,0,1,0,0-12.737Zm4.447,8.668V110.4h21.8a2.436,2.436,0,1,1,0,4.838h-21.8Z",
    transform: "translate(196.895 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    className: "cls-1",
    d: "M0,106.469v21.214H4.44V111.576s12.4,7.7,12.527,7.787c.119-.077,12.716-7.815,12.716-7.815v16.135h4.45V106.469H30.394c0,.026-13.356,8.226-13.356,8.226l-.061.037L3.632,106.427s-3.043.042-3.632.042",
    transform: "translate(0 142.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7495",
    "data-name": "Path 7495",
    className: "cls-1",
    d: "M147.986,106.445a2.014,2.014,0,0,0-1.538.715s-16.689,20.106-17.021,20.5h5.59c.072-.084,2.36-2.865,2.36-2.865h21.148l2.36,2.865h5.576c-.322-.393-16.944-20.494-16.944-20.494a2,2,0,0,0-1.533-.72m-4.648,11.136,4.648-5.635,4.471,5.457,2.893,3.524H140.575l.407-.484Z",
    transform: "translate(173.053 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7496",
    "data-name": "Path 7496",
    className: "cls-1",
    d: "M182.165,106.445a2.008,2.008,0,0,0-1.526.715s-16.7,20.106-17.019,20.5h5.586c.075-.084,2.377-2.865,2.377-2.865h21.13s2.295,2.781,2.367,2.865h5.574c-.337-.393-16.953-20.494-16.953-20.494a1.965,1.965,0,0,0-1.526-.72Zm-4.648,11.136,4.648-5.635,4.469,5.457,2.9,3.524H174.761l.407-.484Z",
    transform: "translate(218.772 142.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7497",
    "data-name": "Path 7497",
    className: "cls-1",
    d: "M269.868,62.568a10.917,10.917,0,0,0-2.617-6.289c-3.975-4.609-12.889-14.672-25.315-27.1s-22.5-21.344-27.1-25.318a10.884,10.884,0,0,0-6.291-2.615C202.643.8,189.67,0,171.487,0S140.332.8,134.43,1.246a10.886,10.886,0,0,0-6.289,2.618c-4.606,3.973-14.667,12.884-27.1,25.315C88.163,42.056,79.547,51.8,75.7,56.284a10.889,10.889,0,0,0-2.594,6.261c-.451,5.889-1.248,18.872-1.248,37.082,0,17.582.813,31,1.262,37.064a10.9,10.9,0,0,0,2.6,6.3c3.854,4.492,12.466,14.228,25.322,27.084,12.433,12.433,22.494,21.344,27.1,25.318a10.447,10.447,0,0,0,6.289,2.19c5.9.451,18.874,1.246,37.057,1.246s31.156-.795,37.057-1.246a10.442,10.442,0,0,0,6.289-2.19c4.609-3.973,14.67-12.884,27.1-25.318,12.856-12.856,21.466-22.592,25.32-27.084a10.9,10.9,0,0,0,2.6-6.3c.449-6.067,1.26-19.484,1.26-37.064,0-18.182-.8-31.158-1.246-37.059m-7.829,71.463a9.232,9.232,0,0,1-2.2,5.324c-3.461,4.043-11.454,13.106-23.485,25.138-11.641,11.641-21.022,19.928-25.163,23.492a9.257,9.257,0,0,1-5.322,2.209c-5.307.411-17.367,1.166-34.381,1.166s-29.073-.755-34.378-1.166a9.257,9.257,0,0,1-5.322-2.209c-4.144-3.564-13.525-11.851-25.166-23.492C94.593,152.461,86.6,143.4,83.139,139.355a9.232,9.232,0,0,1-2.2-5.324c-.409-5.448-1.183-17.942-1.183-34.4,0-17.054.76-29.132,1.171-34.418a9.228,9.228,0,0,1,2.188-5.284c3.45-4.029,11.452-13.1,23.509-25.163,11.641-11.641,21.022-19.928,25.166-23.492a9.242,9.242,0,0,1,5.322-2.209c5.3-.411,17.364-1.169,34.378-1.169s29.073.757,34.378,1.169a9.252,9.252,0,0,1,5.324,2.206c4.139,3.564,13.518,11.849,25.163,23.5s19.926,21.02,23.492,25.161a9.256,9.256,0,0,1,2.208,5.322c.411,5.308,1.169,17.369,1.169,34.383,0,16.46-.774,28.956-1.183,34.4",
    transform: "translate(96.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7498",
    "data-name": "Path 7498",
    className: "cls-1",
    d: "M190.271,69.451c-.143-6.661-.673-12.478-.851-13.763a13.092,13.092,0,0,0-1.454-1.839c-5.712-6.467-11.461-12.716-19.276-20.5C153.485,18.22,145.315,11.047,143.3,9.64c-1.5-.168-4.275-.393-11.777-.727-5.978-.264-13.55-.428-14.186-.4-.028,1.327-.136,101.233-.037,158.056,0,1.035.037,1.37.037,1.37s17.533.159,26.016-1.028c5.8-4.863,16.806-15.263,24.836-23.287,8.57-8.666,15.929-16.556,17.8-18.764.773-.916,2.54-2.811,3.456-4.1.131-1.091.217-2.019.344-4.062.617-10.04.746-28.04.746-28.627-.781-.049-27.033-.021-27.608,0-.019.444.037,13.791.037,13.864.313.016,12.884-.009,13.342.007-.009.238-.353,11.375-.64,13.228-1,1.388-2.6,2.847-4.38,4.842-1.933,2.164-4.7,5.09-10.4,10.93-7.133,7.31-18.232,17.7-23.189,22.076.056-.666-.117-128.4-.063-129.68,1.3,1.082,4.417,3.936,5.289,4.754,6.034,5.66,12.337,11.459,17.465,16.825,7.49,7.841,15,15.99,15.329,16.556.1.594.416,7.4.4,7.96.521.051,13.6-.028,14.114.012",
    transform: "translate(156.785 11.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7499",
    "data-name": "Path 7499",
    className: "cls-1",
    d: "M133.151,167.295c2.1.112,10.734.587,18.643.619.689,0,1.561.021,1.933,0,.023-.743,0-1.1,0-1.781,0-58.28-.012-156.056-.012-156.056s-.042-.582-.065-1.545c-.538-.021-4.728-.091-10,.147-5.137.234-10.054.414-10.533.467-.185.444-6.619,13.6-13.209,29.945C111.29,60.463,107.728,71.1,107.728,71.1s-.32-.407-2.987-4.959c-4.433-7.56-9.15-15.9-11.821-19.8-.465-.678-1.281-1.853-1.281-1.853a5.256,5.256,0,0,0-.86.724c-1.528,1.416-7.621,8.332-8.9,9.827-.617.72-.446.678-.5.89-.107,1.388-.855,12.534-1,29.66-.147,17.619.252,26.865,1.068,35.18a114.037,114.037,0,0,0,7.691,8.759c2.421,2.564,6.915,7.236,6.962,7.236,0,0-.566-7.862-.617-9.255-.531-10.947-.975-21.069-1.059-33.712-.03-1.334-.028-15.2-.028-15.2l6.562,11.48,9.348,16.547.3.259c3.312-8.79,7.5-20.718,11.9-32.224,3.447-9.021,7.063-17.551,10.208-25.673a3.3,3.3,0,0,0,.428-.961s.115,15.871,0,18.764c0,45.711-.026,75.576.035,100.461",
    transform: "translate(107.437 11.374)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/Logo Proyecto.6fc2037666e2707bf68501550cb8aeae.svg";
export { ForwardRef as ReactComponent };